/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_window_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Window size (bp)`)
};

const es_gcskew_window_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de ventana (pb)`)
};

const de_gcskew_window_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fenstergröße (bp)`)
};

const nl_gcskew_window_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venstergrootte (bp)`)
};

const fr_gcskew_window_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille de fenêtre (pb)`)
};

const it_gcskew_window_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione della finestra (bp)`)
};

const pt_br2_gcskew_window_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da janela (pb)`)
};

const pt_gcskew_window_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da janela (pb)`)
};

const ja_gcskew_window_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`窓サイズ (bp)`)
};

const zh_gcskew_window_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`窗口大小（bp）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_window_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_window_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_window_label", locale)
	if (locale === "en") return en_gcskew_window_label(inputs)
	if (locale === "es") return es_gcskew_window_label(inputs)
	if (locale === "de") return de_gcskew_window_label(inputs)
	if (locale === "nl") return nl_gcskew_window_label(inputs)
	if (locale === "fr") return fr_gcskew_window_label(inputs)
	if (locale === "it") return it_gcskew_window_label(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_window_label(inputs)
	if (locale === "pt") return pt_gcskew_window_label(inputs)
	if (locale === "ja") return ja_gcskew_window_label(inputs)
	return zh_gcskew_window_label(inputs)
};